import React from 'react';
import { Link } from '@cloudscape-design/components-themed/components';
const ExternalLink = (props) => {
    return React.createElement(Link, Object.assign({ href: props.to, external: true }, props), props.label);
};
export default ExternalLink;
